<template>
  <div class="page">
    <div class="top-back">
      <!-- <div class="back" @click="black"><img src="@/assets/userNew/icon36.png"></div> -->
      <div class="code">{{ recordLoginText }}</div>
    </div>
    <div class="grille">
      <div class="grille-item" @click="toRecharge">
        <div class="img-1">
          <img src="@/assets/userNew/icon29.png" alt="">
        </div>
        <div class="icon-text">套餐订购</div>
      </div>
      <div class="grille-item" @click="toBalanceRecharge">
        <div class="img-1">
          <img src="@/assets/userNew/icon42.png" alt="">
        </div>
        <div class="icon-text">余额充值</div>
      </div>

      <div class="grille-item" @click="toKefu">
        <div class="img-1">
          <img src="@/assets/userNew/icon27.png" alt="">
        </div>
        <div class="icon-text">联系客服</div>
      </div>

      <div class="grille-item" @click="gotoMore">
        <div class="img-1">
          <img src="@/assets/userNew/icon28.png" alt="">
        </div>
        <div class="icon-text">更多</div>
      </div>

      <!-- <div class="grille-item" @click="toSupplierAuth">
        <div class="img-1">
          <img src="@/assets/userNew/icon26.png" alt="">
        </div>
        <div class="icon-text">实名认证</div>
      </div> -->



      <!-- <div class="grille-item" @click="activeSim">
        <div class="img-1">
          <img src="@/assets/userNew/30.png" alt="">
        </div>
        <div class="icon-text">一键复机</div>
      </div>

      <div class="grille-item" @click="kfClick">
        <div class="img-1">
          <img src="@/assets/userNew/icon39.png" alt="">
        </div>
        <div class="icon-text">联系客服</div>
      </div>

     <div class="grille-item" @click="buyCard()">
        <div class="img-1">
          <img src="@/assets/home/27.png" alt="">
        </div>
        <div class="icon-text">在线购买</div>
      </div>

       <div class="grille-item" @click="outLogin">
        <div class="img-1">
          <img src="@/assets/userNew/icon48.png" alt="">
        </div>
        <div class="icon-text">退出登录</div>
      </div> -->

    </div>
    <div class="w upgrade">
      <div class="img"><img src="@/assets/userNew/icon38.png" alt=""></div>
      <div class="text">{{ simInfo.pkgName }}</div>
      <div class="el-btn" @click="toRecharge">立即订购</div>
    </div>
    <div class="allowance">
      <div class="el-cl-flex">
        <div class="zll">
          <div class="zll-num">{{ fluxMtoG(simInfo.flowRate || 0) }}GB</div>
          <div class="zll-zh">总流量</div>
        </div>
        <div class="zll">
          <div class="zll-num">{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}GB</div>
          <div class="zll-zh">剩余流量</div>
        </div>
        <!-- <div class="zll">
          <div class="zll-num">{{ simInfo.endTimeDay || 0 }}天</div>
          <div class="zll-zh">账期剩余时长</div>
        </div> -->
        <div class="zll">
          <div class="zll-num">{{ simInfo.cardStateName }}</div>
          <div class="zll-zh">卡状态</div>
        </div>
        <div class="zll">
          <div class="zll-num">--</div>
          <div class="zll-zh zll-zh2" @click="isShow = !isShow">
            余额<van-icon :name="isShow ? 'arrow-down' : 'arrow-up'" />
          </div>
        </div>
      </div>
      <div v-if="isShow" class="balanceBox">
        <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon30.png" alt="">
          </div>
          <div class="text12-view">卡余额：</div>
          <div class="text-num">
            ￥{{ money_format(userAccount.amount / 100, 2, ".", ",") * 1 }}
          </div>
          <div class="text-link" @click="toBalanceRecharge">立即充值</div>
        </div>
        <!-- <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon33.png" alt="">
          </div>
          <div class="text12-view">设备管理：</div>
          <div class="text-link" @click="detailsTo">前去设置</div>
        </div> -->

        <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon31.png" alt="">
          </div>
          <div class="text12-view">实名状态：</div>
          <div class="text-num">{{ isAuthName }}</div>
          <div class="text-link" v-if="isAuthName != '已实名'" @click="toSupplierAuth">前往实名</div>
        </div>

        <div class="balance-item">
          <div class="balance-icon">
            <img src="@/assets/userNew/icon32.png" alt="">
          </div>
          <div class="text12-view">过期时间：</div>
          <div class="text-num">{{ simInfo.endTimeString }}</div>
          <div class="text-link" @click="toRecharge">充值套餐</div>
        </div>


      </div>
      <div class="btn-link">
        <img src="@/assets/userNew/8.png" alt="" @click="gotoView">
      </div>
    </div>
    <div class="allowance w">
      <div class="t">
        <!-- <div class="t-img">
          <img src="@/assets/userNew/9.png" alt="">
        </div> -->
        <div class="hit">热门活动 |</div>
        <div class="hit1">热门畅销 为你精选</div>
      </div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item @click="toBalanceRecharge">
          <img v-if="newHomeImg && newHomeImg != null && newHomeImg != 'null' && newHomeImg != ''" :src="newHomeImg"
            alt="">
          <img v-else src="@/assets/userNew/aa.jpg" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>


    <van-dialog v-model="isShowAuth" title="实名认证提示" :show-confirm-button="false">
      <div class="dialog-text">
        根据国家规定，手机卡需要进行实名认证，实名认证后方可使用。
      </div>
      <div class="dialog-text">
        如果您已操作实名认证，无需重复操作，重启手机后即可畅享网络。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toSupplierAuth">立即实名</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="isShowPrice" title="套餐订购提示" :show-confirm-button="false">
      <div class="dialog-text">
        您已成功参与购买优惠券活动,每个月购买套餐可自动抵扣金额，订购套餐后即可畅享网络。
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toRecharge()">立即订购</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="isChangeCard" title="换卡通知" :show-confirm-button="false">
      <div class="dialog-text">
        关于免费升级更换工业级物联网卡的通知
        <br />

        尊敬的客户：
        <br />

        您好！近期收到部分用户反馈，普通流量卡在高温、潮湿等复杂环境下易出现损坏，影响正常使用。
        <br />

        为提升您的使用稳定性与耐用性，我司现免费为您升级更换工业级物联网卡（更换的卡品为联通）。该卡具备耐高温、耐腐蚀、抗干扰等特性，可适应各类严苛环境，保障长期稳定运行。
        <br />
        请您及时填写换卡信息
        <br />
        - 新卡将在信息提交后24小时内发出；
        <br />

        -收到货需要联系我们转移套餐实名激活使用。
        <br />

        感谢您的理解与配合，祝您使用愉快！
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toChangeCard">去换新卡</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="isShowDiejiaQuan" title="叠加券活动通知" :show-confirm-button="false">
      <div class="dialog-text">您有一张叠加券待领取，叠加券可与优惠券一起使用。 套餐可低至0元购！</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toDiejiaun">去看看</van-button>
      </div>
    </van-dialog>


    <van-dialog v-model="isShowYueHuodong" title="预存送优惠券活动" :show-confirm-button="false">
      <div class="dialog-text">限时预存活动！充值账户余额 可免费多得优惠券！ 最高可直接减免套餐金额！</div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toYueHuodong">去看看</van-button>
      </div>
    </van-dialog>




    <van-overlay :show="isTitle">
      <div class="wrapper">
        <div class="wrapper-img" @click="toTitle()">
          <img style="width: 100%;height: 100%;" :src="titleImg" />
        </div>
        <img src="@/assets/close.png" class="close" @click="cancelTitle" />
      </div>
    </van-overlay>



    <van-dialog v-model="lingshiFlg" title="紧急通知" :show-confirm-button="false">
      <div class="dialog-text">
        尊敬的各位用户：
        <br />
        您好！移动系统将于3月31日—4月3日进行升级维护。升级后，移动公司要求上传设备使用图片，上传时间截止到4.1日凌晨12点，请您及时上传，未及时上传需要二次实名后恢复使用。<br />
        本次升级涉及号段：108、109开头的移动号码。
        升级期间可能出现部分断网，预计48–72小时恢复。
        <br />
        ⚠️ 重要提醒：断网后请勿拔出SIM卡、请勿移动设备、请勿动卡（重复三遍）。
        <br />
        感谢您的理解与配合，给您带来不便敬请谅解！
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="lingshiFlg = false">取消</van-button>
        <van-button type="primary" class="dialog-btn3" @click="toLingshi()">去换新卡</van-button>
      </div>
    </van-dialog>



  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      lingshiFlg: false,
      isTitle: false,
      titleImg: "http://vx.iot688.cn:8888/" + localStorage.getItem("titleImg"),
      titleUrl: localStorage.getItem("titleUrl"),


      showPower: false,





      newHomeImg: localStorage.getItem("newHomeImg"),
      newHomeUrl: localStorage.getItem("newHomeUrl"),

      isAuth: localStorage.getItem("isAuth"),
      isAgentLogin: localStorage.getItem("isAgentLogin"),
      yucun: localStorage.getItem("yucun"),
      isSale: localStorage.getItem("isSale"),
      shebeiLogin: localStorage.getItem("shebeiLogin"),
      ishavePkg: localStorage.getItem("ishavePkg"),
      ishavePrice: localStorage.getItem("ishavePrice"),
      kefuUrl: localStorage.getItem("kefuUrl"),


      isChangeCard: false,
      isAuthName: '未实名/未知', //实名状态
      isShowAuth: false,

      appshowimg: false,
      canChangeCard: false,
      userAccount: {},
      simInfo: {},
      show: false,
      reacheShow: false,
      reacheShows: false,
      isShow: true,
      iccid: localStorage.getItem('iccid'),
      recordLoginText: localStorage.getItem('recordLoginText'),
      isNewPage: localStorage.getItem('isNewPage'),
      alreadyHasAccount: false,



      ctccAuthShow: false,
      cmccXxtx: false,
      cuccAuthShow: false,
      cmccAuthShow: false,
      otherAuth: false,
      otherUrl: '',
      isShowPrice: false,

      isShowDiejiaQuan: false,
      isShowYueHuodong: false,
    }
  },
  async created() {
    await wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: localStorage.getItem("intoNo") }, "post").then((res) => {
      if (res.data.code == 200) {
        this.isAuthName = "已实名";
      } else if (res.data.code == 302) {
        this.isAuthName = "请先购买套餐";
      }
      sessionStorage.setItem("alreadyCertification", "true");
    });
    await this.getUserSimInfo();
    await this.getAccount();
    /**   换卡判断       **/
    let fd = new FormData();
    fd.append("iccid", localStorage.getItem("iccid"));
    await wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
      if (res.data.code == "200") { //换卡提醒
        this.isChangeCard = true;
        localStorage.setItem('isTochangeCard', 1)
      } else if (
        this.isSale > 0 &&
        this.ishavePkg == 0 &&
        this.ishavePrice == 1 &&
        this.isAuthName == '请先购买套餐'
      ) {
        this.isShowPrice = true;
      } else if (this.isAuthName == '未实名/未知') {
        this.isShowAuth = true;
      } else if (this.yucun == 1) {
        this.isShowYueHuodong = true;
      } else if (this.yucun == 3) {
        this.isShowDiejiaQuan = true;
      } else if (localStorage.getItem("isTitle") == 1) {
        this.isTitle = true;
      }
    });
  },
  methods: {
    toLingshi() {
      window.location.href = 'https://www.kdocs.cn/l/crlu39YsuYUH';
    },
    cancelTitle() {
      this.isTitle = false;
      localStorage.setItem('isTitle', 0);
    },

    toTitle() {
      localStorage.setItem("isTitle", 0);
      if (this.titleUrl && this.titleUrl == '套餐') {
        this.$router.push('/userNew/recharge');
      } else if (this.titleUrl && this.titleUrl == '余额') {
        this.$router.push('/user/balanceRecharge');
      } else if (this.titleUrl) {
        window.location.href = this.titleUrl;
      }
    },





    toUrlLoad() {
      if (!this.newHomeUrl || this.newHomeUrl == '购卡' || this.newHomeUrl == 'null') {
        this.$router.push("/user/liuliangka?agentId=" + this.simInfo.agentId);
      } else {
        window.location.href = this.newHomeUrl;
      }
    },
    toKefu() {
      let url = this.kefuUrl
      if (url) {
        window.location.href = url;
      } else {
        Dialog.alert({ title: "提示", message: '客服即将上线！如有其它疑问，请点更多->常见问题中寻找帮助' });
      }
    },
    toDiejiaun() {
      this.$router.push("/user/huodong2");
    },
    toYueHuodong() {
      this.$router.push("/user/huodong");
    },
    cancelChange() {
      this.isShowYueHuodong = false,
        this.isShowAuth = false;
      this.isChangeCard = false;
      this.isShowPrice = false;
      this.isShowDiejiaQuan = false;
    },
    toChangeCard() {
      this.$router.push({
        name: "userChgCard",
        query: {
          oldIccid: localStorage.getItem("iccid")
        },
      });
    },
    getUserSimInfo() {
      wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(
        (res) => {
          if (res.data.code == 200) {
            let result = res.data.data;


            if (result.flowRatePool == "电信") {
              this.ctccAuthShow = true;
            } else if (result.flowRatePool == "联通") {
              this.cuccAuthShow = true;
            } else if (result.flowRatePool == "前海") {
              this.qianhaiSHow = true;
            } else if (result.flowRatePool == "移动") {
              this.cmccAuthShow = true;
            } else if (result.flowRatePool == "乐语") {
              this.leyuAuthShow = true;
            } else if (result.flowRatePool == "移动接口") {
              this.cmccXxtx = true;
            } else {
              if (result.flowRatePool.indexOf('?') > 0) {
                this.otherUrl = result.flowRatePool + '&cn=' + localStorage.getItem('recordLoginText');
              } else {
                this.otherUrl = result.flowRatePool + "?cn=" + localStorage.getItem('recordLoginText');
              }

              this.otherAuth = true;
            }
            localStorage.setItem('simInfoMap', result);
            sessionStorage.setItem("supplierCode", result.supplierCode);

            this.simInfo = result;

            if (result.simPackageList.length > 1) {
              for (let i = 0; i < result.simPackageList.length; i++) {
                if (
                  result.simPackageList[i].flowRatePercent &&
                  (result.simPackageList[i].flowRatePercent / 100) *
                  result.simPackageList[i].flowRate >
                  result.simPackageList[i].usedFlowRate
                ) {
                  this.simInfo.packageName =
                    result.simPackageList[i].packageName;
                  this.simInfo.endTime = result.simPackageList[i].endTime;
                  break;
                }
              }
            } else if (result.simPackageList.length == 1) {
              this.simInfo.packageName = result.simPackageList[0].packageName;
              this.simInfo.endTime = result.simPackageList[0].endTime;
            }
            this.simInfo.simId = this.simInfo.simPackageList[0]
              ? this.simInfo.simPackageList[0].simId
              : "";
          }
        }
      );
    },
    getAccount() {
      let param = {
        iccid: this.$store.state.iccid,
        mobile: localStorage.getItem("mobile"),
      };
      wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
        (res) => {
          if (res.data.code == 200) {
            this.userAccount = res.data.data;
            this.alreadyHasAccount = true;
            localStorage.setItem("userSimAmount", this.userAccount.amount)
            localStorage.setItem('alreadyHasAccount', 1);
          } else {
            localStorage.setItem("userSimAmount", 0);
            localStorage.setItem('alreadyHasAccount', 0);
          }
        }
      );
    },
    toSupplierAuth() {
      if (this.isAuthName == '已实名') {
        Dialog.alert({ title: "提示", message: '已完成实名认证，无需再次实名！' });
      } else if (this.isAuthName == '请先购买套餐') {
        Dialog.confirm({
          message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
          confirmButtonText: "去购买",
          cancelButtonText: "取消",
        }).then(() => {
          this.$router.replace('/userNew/recharge');
        })
          .catch(() => { });
      } else {
        if (this.cmccXxtx == true) {
          wxRequest(
            "wxAuth/cmcc/auth",
            { iccid: this.$store.state.iccid },
            "post"
          ).then((res) => {
            if (res.data.code == "200") {
              window.location.href = res.data.data;
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
              });
            }
          });
        } else if (this.ctccAuthShow == true) {
          this.$router.push({
            path: "/user/ctccAuth",
            query: { realNameCard: 1 },
          });
        } else if (this.cuccAuthShow == true) {
          window.location.href = "http://vx.iot688.cn/#/user/cuccAuth";
        } else if (this.cmccAuthShow == true) {
          this.$router.push({
            path: "/user/cmccAuth",
            query: { realNameCard: 1 },
          });
        } else {
          window.location.href = this.otherUrl;
        }

      }
    },
    toRecharge() {
      let fd = new FormData();
      fd.append("supplierId", sessionStorage.getItem("supplierCode"));
      wxRequest("sim/invent/state", fd, "post").then((res) => {
        if (res.data.code == 200) {
          if (this.userAccount.amount < 0) {
            Dialog.confirm({
              title: "提示",
              message: "您的账户余额已透支，请先充值账户余额！",
            })
              .then(() => {
                this.$router.push({
                  path: "/user/balanceRecharge",
                  query: {
                    iccid: this.$store.state.iccid,
                  },
                });
              })
              .catch(() => { });
          } else {
            this.$router.push({
              path: "/userNew/recharge",
              query: {
                iccid: this.$store.state.iccid,
              },
            });

          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          });
        }
      });

    },
    toBalanceRecharge() {
      if (this.yucun == 1 || this.yucun == 888) {
        this.$router.push({
          path: "/user/huodong",
          query: {
            iccid: this.$store.state.iccid,
          },
        });
      } else {
        this.$router.push({
          path: "/user/balanceRecharge",
          query: {
            iccid: this.$store.state.iccid,
          },
        });
      }


    },
    gotoMore() {
      this.$router.push({
        path: '/userNew/operation'
      })
    },
    detailsTo() {
      //  this.$router.push({
      //   name: "applySalePkg",
      //   query: { iccid: this.simInfo.iccid },
      // });
      this.$router.push({
        path: "/user/device"
      });

    },
    gotoView() {
      this.$router.push({
        path: '/userNew/diagnosis'
      })
    }


  }
}
</script>
<style lang="less" scoped>
div {
  display: flex;
  flex-grow: 0;
  flex-basis: auto;
  align-items: stretch;
  flex-direction: column;
}

.w {
  width: 90%;
}

.page {
  background: #f7f8fa url("../../assets/userNew/icon37.png") no-repeat;
  background-position: 0% 0%;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;

  .top-back {
    flex-direction: row;
    align-items: center;
    height: 60px;
    display: flex;
    text-align: center;
    font-size: 17px;
    color: rgb(6, 18, 30);
    font-weight: bold;

    .back {
      align-items: center;
      width: 60px;

      img {
        width: 20px;
      }
    }

    .code {
      // width: calc(100% - 40px);
      width: 100%;
    }
  }

  .grille {
    display: flex;
    align-self: center;
    flex-direction: row;
    margin: 10px auto;
    background-color: hsla(0, 0%, 100%, 0.3);
    border-radius: 16px;
    align-content: flex-start;
    flex-wrap: wrap;
    width: 90%;

    .grille-item {
      // min-width: 84px;
      width: 25%;
      margin: 10px 0px 10px;
      align-items: center;

      .img-1 {
        width: 46px;
        height: 46px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .icon-text {
        font-size: 12px;
        font-weight: 700;
        color: #3d444d;
        margin-top: 5px;
      }
    }
  }

  .upgrade {
    align-self: center;
    flex-direction: row;
    margin-top: 5px;
    background-color: #fff;
    height: 40px;
    align-items: center;
    border-radius: 7px;

    .img {
      height: 15px;
      margin-right: 7px;
      width: 62px;
      margin-left: 16px;

      img {
        height: 100%;
      }
    }

    .text {
      font-size: 14px;
      color: #06121e;
      flex: 1;
    }

    .el-btn {
      padding: 4px 8px;
      border-radius: 200px;
      margin-right: 5px;
      background-color: #f9f5dc;
      font-size: 13px;
      font-weight: 500;
      color: #d8982e;
      border: 0;
    }
  }

  .allowance {
    align-self: center;
    flex-direction: column;
    margin-top: 15px;
    justify-content: center;
    background: #fff;
    border-radius: 20px;
    padding: 10px;
    width: 87%;

    .el-cl-flex {
      width: 320px;
      flex-direction: row;
      justify-content: space-around;
      margin-top: 7px;

      .zll {
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .zll-num {
        font-size: 22px;
        line-height: 22px;
        font-weight: 600;
        color: #06121e;
        text-align: center;
        margin-top: 10px;
      }

      .zll-zh {
        font-size: 12px;
        color: #8c9198;
        text-align: center;
        margin-top: 3px;
        margin-bottom: 15px;
      }

      .zll-zh2 {
        text-align: center;
        background: #4eb258;
        padding: 4px 8px;
        border-radius: 200px;
        flex-direction: row;
        font-size: 12px;
        color: #fff;
        text-align: center;
      }
    }

    .balanceBox {
      display: flex;
      flex-direction: column;
      background: #f7f8fa;
      border-radius: 8px;
      position: relative;
      margin-top: 5px;
      padding: 0 15px 15px;

      .balance-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin-top: 15px;

        .balance-icon {
          width: 18px;
          height: 18px;
          margin-right: 5px;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .text12-view {
          flex: 1;
        }

        .text-num {
          font-size: 13px;
          color: #06121e;
          font-weight: 700;
        }

        .text-link {
          font-size: 13px;
          font-weight: 500;
          color: #1c96f6;
          text-decoration: underline;
          margin-left: 15px;
        }
      }
    }

    .btn-link {
      height: 78px;
      width: 90%;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .t {
      display: flex;
      flex-direction: row;
      width: 320px;
      align-items: center;
      margin-bottom: 5px;

      .t-img {
        width: 26px;
        height: 26px;
      }

      .hit {
        color: #06121e;
        font-size: 16px;
      }

      .hi1 {
        color: rgb(6, 18, 30);
        font-size: 13px;
      }
    }

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 91px;
      text-align: center;
    }
  }
}

.van-dialog {
  ::v-deep.van-dialog__content {
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  ::v-deep .van-dialog__header {
    font-size: 20px;
    font-weight: 700;
    color: #06121e;
    text-align: center;
    margin-bottom: 10px;
  }

  .dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
  }

  .btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;

    .dialog-btn2 {
      width: 120px;
      height: 47px;
      color: #3476fe;
      text-align: center;
      background: rgba(52, 118, 254, 0.1) !important;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
    }

    .dialog-btn3 {
      width: 130px;
      height: 47px;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
      border: 0;
      color: #fff;
      background: #3476fe;
      text-align: center;
    }
  }
}
</style>


<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 38.2vh;
  left: 50%;
  margin-top: -50%;
  margin-left: -50%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wrapper-img {
    width: 90%;
    height: 65%;
  }

  .close {
    width: 24px;
    position: relative;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
    font-size: .53333rem;
    font-weight: 700;
    line-height: 1;
    margin-top: 60px;
    color: #000;
    text-shadow: 0 0.02667rem 0 #fff;
  }
}
</style>